export const getUser = (params) => {
	return $axios.get("/users", { params });
}; // 获取当前用户信息
export const updateUser = (data) => $axios.post("/user/loginReginfo", data); // 设置用户信息
export const changePwd = (data) => $axios.post("/user/loginEnroll", data);
export const getFollowedList = (params) =>
	$axios.get("/messages/contacts/user", { params });
export const getFansList = (params) =>
	$axios.get("/messages/contacts/frinded", { params });

export const getAccess = (params) =>
	$axios.get("/alipay/users/bill-summary", { params });

export const withDraw = (params) =>
	$axios.get("/alipay/WithdrawRequest", { params });

export const getUserPayList = (params) =>
	$axios.get("/alipay/bill/user/expend", { params });

export const submitRefund = (params) =>
	$axios.get("/alipay/refund/for", { params });

export const getAccountDetail = (params) =>
	$axios.get("/users/bill", { params });
export const cancelAccount = (data) => $axios.post("/user/deleteUserAccount", data);
